import {
	Button,
	Checkbox,
	Col,
	Form,
	Input,
	Popconfirm,
	Row,
	Select,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";

const Truck = (props) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState({});
	const [plantOptions, setPlantOptions] = useState([]);
	const [subplantOptions, setSublantOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingForm, setLoadingForm] = useState(true);
	const [loadingSubplant, setLoadingSubplant] = useState(true);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getPlant();
		getTruck();
	}, []);

	const getPlant = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let plantList = [];
			data.payload.map((item) => {
				plantList.push({
					label: item.name,
					value: item._id,
				});
			});
			setPlantOptions(plantList);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getSublant = async (currentPlant) => {
		const url = api + `/plant/${currentPlant}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let subplantList = [];
			data.subplants.map((item) => {
				subplantList.push({
					label: item.name,
					value: item.name,
				});
			});
			setSublantOptions(subplantList);
			setLoadingSubplant(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getTruck = async () => {
		const url = api + "/truck/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			setInitialValues({
				...initialValues,
				make: data.make,
				model: data.model,
				plates: data.plates,
				number: data.number,
				plant: data.plant ? data.plant : "",
				subplant: data.subplant ? data.subplant : "",
				active: data.active,
				vin: data.vin,
				samsaraTruckId: data.samsaraTruckId || "",
			});
			getSublant(data.plant);
			setLoadingForm(false);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to get truck");
			console.error(err.message);
			return null;
		}
	};

	const deleteTruck = async () => {
		setLoading(true);

		const url = api + "/truck/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.delete(url);
			openNotification("info", "Info", "Truck Deleted");
			setLoading(false);
			props.history.push("/truck/list");
		} catch (err) {
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};

	const truckQR = async () => {
		setLoading(true);
		props.history.push(`/truckqr/${props.match.params.id}`);
	};

	const updateTruck = async (data) => {
		const user = {
			make: data.make,
			model: data.model,
			plates: data.plates,
			number: data.number,
			plant: data.plant,
			subplant: data.subplant,
			active: data.active,
			vin: data.vin,
			samsaraTruckId: data.samsaraTruckId,
		};

		try {
			let url = api + "/truck/" + props.match.params.id;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			await axios.patch(url, user);
			openNotification("success", "Success", "Truck updated");
			setLoading(false);
			props.history.push("/truck/list");
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to update truck");
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		updateTruck(values);
	};

	const onChangePlant = (value) => {
		form.setFieldsValue({ subplant: "" });
		setLoadingSubplant(true);
		getSublant(value);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Make"
							name="make"
							rules={[
								{
									required: true,
									message: "Please fill make",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Model"
							name="model"
							rules={[
								{
									required: true,
									message: "Please fill model",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Plates"
							name="plates"
							rules={[
								{
									required: true,
									message: "Please fill plates",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Truck Number"
							name="number"
							rules={[
								{
									required: true,
									message: "Please fill truck number",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="VIN"
							name="vin"
							rules={[
								{
									required: true,
									message: "Please fill vin",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="Samsara Truck ID"
							name="samsaraTruckId"
							rules={[
								{
									required: true,
									whitespace: true,
									message: "Please fill Samsara truck ID",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Plant"
							name="plant"
							rules={[
								{
									required: true,
									message: "Please select a plant",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select plant`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={plantOptions}
								onChange={onChangePlant}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Subplant"
							name="subplant"
							rules={[
								{
									required: true,
									message: "Please select a subplant",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select subplant`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={subplantOptions}
								disabled={loadingSubplant}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item name="active" valuePropName="checked">
							<Checkbox>Active</Checkbox>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col>
						<Button type="primary" htmlType="submit" loading={loading}>
							Save
						</Button>
					</Col>
					{/* <Col>
                    <Popconfirm
                        title="Delete the user"
                        description="Are you sure to delete this user?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={deleteTruck}
                    >
                        <Button danger type='primary' htmlType='button' loading={loading}>Delete</Button>
                    </Popconfirm>
                </Col> */}
					<Col>
						<Button
							type="primary"
							htmlType="button"
							loading={loading}
							onClick={truckQR}
						>
							QR
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Layout title="Truck" description="Edit Truck" type="medium">
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default Truck;
